import { AUTH_TOKEN_KEY } from '../../../core/constants'
import { useCookies } from 'vue3-cookies'

const { cookies } = useCookies()

export const state: AuthState = {
  isAuthenticated: !!cookies.get(AUTH_TOKEN_KEY),
  partner: [],
  role: 2,
  user: {} as any,
}
